import React from 'react';
import {
  SkeletonPlaceholder,
  Card,
  SkeletonButton,
  Flex,
  Box,
  DecorationLine,
  StickyBox,
} from '@edreamsodigeo/prisma-design-system';

const SkeletonTitleHeaderMapItinerary: React.FC<{ isMetaSummary: boolean }> = ({
  isMetaSummary,
}) => {
  return (
    <Flex
      mb="base"
      justifyContent="space-between"
      alignItems="center"
      px="base"
      pt="base"
    >
      <SkeletonButton sx={{ width: '60%' }}></SkeletonButton>
      {!isMetaSummary && (
        <SkeletonButton data-testid="icon-skeleton" sx={{ width: '32px' }} />
      )}
    </Flex>
  );
};

const SkeletonTitleItinerary: React.FC = () => {
  return (
    <Flex mb="base" justifyContent="space-between" alignItems="center">
      <SkeletonButton sx={{ width: '40%', height: '16px' }} />
      <SkeletonPlaceholder size="small" />
    </Flex>
  );
};

const SkeletonItinerary: React.FC = () => {
  return (
    <>
      {/* 1st row */}
      <Flex>
        <Flex flexDirection="column" width="70px" pb="small">
          <Box mb="1x_small">
            <SkeletonPlaceholder size="large" />
          </Box>
          <SkeletonPlaceholder size="medium" />
        </Flex>
        <DecorationLine lineType="solid" theme="grey" decorationType="circle" />
        <Flex flexDirection="column" width="100%" pb="small">
          <SkeletonButton sx={{ width: '90%', height: '16px' }} />
        </Flex>
      </Flex>
      {/* 2nd row */}
      <Flex>
        <Flex flexDirection="column" width="70px" pb="1x_big"></Flex>
        <DecorationLine lineType="solid" theme="grey" decorationType="none" />
        <Flex flexDirection="column" width="100%" pb="1x_big">
          <Flex flexDirection="row" mb="1x_small">
            <Box pr="1x_small">
              <SkeletonButton sx={{ width: '16px', height: '16px' }} />
            </Box>
            <SkeletonPlaceholder size="medium" />
          </Flex>
          <SkeletonButton sx={{ width: 'calc(24px + 60%)', height: '16px' }} />
        </Flex>
      </Flex>
      {/* 3rd row */}
      <Flex>
        <Flex flexDirection="column" width="70px">
          <Box mb="1x_small">
            <SkeletonPlaceholder size="large" />
          </Box>
          <SkeletonPlaceholder size="medium" />
        </Flex>
        <DecorationLine lineType="none" theme="grey" decorationType="disk" />{' '}
        <Flex flexDirection="column" width="100%">
          <SkeletonButton sx={{ width: '90%', height: '16px' }} />
        </Flex>
      </Flex>
      {/* kind of bagge */}
      <Box pt="1x_big">
        <SkeletonButton sx={{ width: '35%', height: '16px' }} />
      </Box>
    </>
  );
};

export const SkeletonContinueSection: React.FC = () => {
  return (
    <StickyBox to="bottom">
      <Card p="base">
        <Flex justifyContent="center">
          <Flex width="50%" flexDirection="column" justifyContent="center">
            <SkeletonPlaceholder size="small" />
            <SkeletonButton
              sx={{ width: '40%', height: '16px', marginTop: '1x_small' }}
            />
          </Flex>
          <Flex justifyContent="center" width="50%">
            <SkeletonButton />
          </Flex>
        </Flex>
      </Card>
    </StickyBox>
  );
};

const SkeletonMapItinerary: React.FC<{ isMetaSummary: boolean }> = ({
  isMetaSummary = false,
}) => {
  const Wrapper = isMetaSummary ? Box : Card;
  return (
    <>
      <SkeletonTitleHeaderMapItinerary isMetaSummary={isMetaSummary} />
      <Wrapper p="base">
        <SkeletonTitleItinerary />
        <SkeletonItinerary />
        <Box pt="1x_big">
          <SkeletonTitleItinerary />
          <SkeletonItinerary />
        </Box>
      </Wrapper>
    </>
  );
};
export default SkeletonMapItinerary;
